<ng-container *transloco="let t; read: 'settings.deviceManufacturer'">
  <ng-container *transloco="let tGlobal; read: 'global'">
    @if (vm$ | async; as vm) {
      <div class="componentContainer">
        <section class="xs12col componentHeader">
          <h1>{{t('title')}}</h1>
        </section>
        <section class="oneCol">
          <div class="xs12col">
            <div class="boxContainer">
              <div class="box">
                <kendo-grid
                  [data]="{data: vm.deviceManufacturers, total: vm.total}"
                    [sortable]="{
                      allowUnsort: false
                    }"
                  [sort]="sort"
                  (sortChange)="sortChange($event, vm.searchRequest)"
                  (edit)="editHandler($event)"
                  (cancel)="cancelHandler($event)"
                  (save)="saveHandler($event)"
                  (add)="addHandler($event)"
                  (remove)="showDeleteModal = $event.dataItem.id"
                  [skip]="vm.gridState.skip"
                  [pageSize]="vm.gridState.pageSize"
                  [pageable]="true"
                  (pageChange)="pageChangeSub$.next($event)"
                  [resizable]="true">
                  <ng-template kendoGridToolbarTemplate>
                    <a kendoGridAddCommand class="addIcon">
                      <span class="icon">
                        <img src="../../../assets/icons/add-icon.svg">
                      </span>
                      {{t('add')}}
                    </a>
                  </ng-template>
                  <kendo-grid-column field="name" [title]="t('name')" media="(min-width: 993px)">
                    <ng-template
                      kendoGridEditTemplate
                      let-isNew="isNew"
                      let-formGroup="formGroup"
                      >
                      <kendo-textbox
                        [formControl]="formGroup.get('name')"
                      ></kendo-textbox>
                      @if (formGroup.get('name').touched && formGroup.get('name').hasError('required') && !formGroup.get('name').value) {
                        <kendo-formerror>
                        {{t('isRequired')}}</kendo-formerror>
                      }
                      @if (formGroup.get('name').hasError('deviceManufacturerExists') && formGroup.get('name').touched) {
                        <kendo-formerror>
                        {{t('isNotUnique')}}</kendo-formerror>
                      }
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-command-column
                    [hidden]="!('Permissions.DeviceManufacturers.Update' | permission) || !('Permissions.DeviceManufacturers.Delete' | permission)"
                    media="(min-width: 993px)"
                    >
                    <ng-template kendoGridCellTemplate let-isNew="isNew">
                      <a kendoGridEditCommand [attr.tooltip]="t('edit')" flow="up" class="actionIcon"><img src="../../../assets/icons/edit-icon.svg"></a>
                      <a kendoGridRemoveCommand [attr.tooltip]="t('delete')" flow="up" class="actionIcon"><img src="../../../assets/icons/delete-icon.svg"></a>
                      <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
                        {{ isNew ? t('add') : t('save') }}
                      </button>
                      <button kendoGridCancelCommand>
                        {{ isNew ? t('cancel') : t('cancel') }}
                      </button>
                    </ng-template>
                  </kendo-grid-command-column>
                  <!-- MOBILE GRID -->
                  <kendo-grid-column-group media="(max-width: 992px)">
                    <kendo-grid-column>
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <h4 class="mobileGridHeader">{{t('name')}}</h4>
                        <span>{{dataItem.name}}</span>
                      </ng-template>
                      <ng-template
                        kendoGridEditTemplate
                        let-isNew="isNew"
                        let-formGroup="formGroup">
                        <h4 class="mobileGridHeader">{{t('name')}}</h4>
                        <kendo-textbox [formControl]="formGroup.get('name')"></kendo-textbox>
                        @if (formGroup.get('name').touched && formGroup.get('name').hasError('required') && !formGroup.get('name').value) {
                          <kendo-formerror>
                          {{t('isRequired')}}</kendo-formerror>
                        }
                        @if (formGroup.get('name').hasError('deviceManufacturerExists') && formGroup.get('name').touched) {
                          <kendo-formerror>
                          {{t('isNotUnique')}}</kendo-formerror>
                        }
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-command-column
                      [hidden]="!('Permissions.DeviceManufacturers.Update' | permission) || !('Permissions.DeviceManufacturers.Delete' | permission)"
                      media="(max-width: 992px)"
                      >
                      <ng-template kendoGridCellTemplate let-isNew="isNew">
                        <a kendoGridEditCommand [attr.tooltip]="t('edit')" flow="up" class="actionIcon"><img src="../../../assets/icons/edit-icon.svg"></a>
                        <a kendoGridRemoveCommand [attr.tooltip]="t('delete')" flow="up" class="actionIcon"><img src="../../../assets/icons/delete-icon.svg"></a>
                        <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
                          {{ isNew ? t('add') : t('save') }}
                        </button>
                        <button kendoGridCancelCommand>
                          {{ isNew ? t('cancel') : t('cancel') }}
                        </button>
                      </ng-template>
                    </kendo-grid-command-column>
                  </kendo-grid-column-group>
                  <!-- IF NO RESULTS COULD BE FOUND -->
                  <ng-template kendoGridNoRecordsTemplate>
                    <div class="text pl">{{ t("noResults") }}</div>
                  </ng-template>
                  <!-- Paging -->
                  <ng-template
                    let-totalPages="totalPages"
                    let-currentPage="currentPage"
                    kendoPagerTemplate
                    >
                    <div class="width100 flex -spaceAround -alignCenter mts flex-wrap">
                      <div class="flex padding-right-large">
                        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                        <kendo-pager-numeric-buttons
                          [buttonCount]="5"
                        ></kendo-pager-numeric-buttons>
                        <kendo-pager-next-buttons></kendo-pager-next-buttons>
                      </div>
                      <div class="pageSize flex align-center">
                        <kendo-buttongroup
                          [selection]="'single'"
                          id="pageBtnGroup"
                          class="-purple"
                          >
                          <button
                            (click)="
                              pageChangeSub$.next({
                                skip: vm.gridState.skip,
                                take: pageSizes.Small
                              })
                            "
                            kendoButton
                            [selected]="vm.gridState.pageSize === pageSizes.Small"
                            [toggleable]="true"
                            >
                            {{ pageSizes.Small }}
                          </button>
                          <button
                            (click)="
                              pageChangeSub$.next({
                                skip: vm.gridState.skip,
                                take: pageSizes.Medium
                              })
                            "
                            kendoButton
                            [selected]="vm.gridState.pageSize === pageSizes.Medium"
                            [toggleable]="true"
                            >
                            {{ pageSizes.Medium }}
                          </button>
                          <button
                            (click)="
                              pageChangeSub$.next({
                                skip: vm.gridState.skip,
                                take: pageSizes.Large
                              })
                            "
                            kendoButton
                            [selected]="vm.gridState.pageSize === pageSizes.Large"
                            [toggleable]="true"
                            >
                            {{ pageSizes.Large }}
                          </button>
                        </kendo-buttongroup>
                      </div>
                    </div>
                  </ng-template>
                </kendo-grid>
              </div>
            </div>
          </div>
          @if (showDeleteModal) {
            <kendo-window
              [title]="t('deleteConfirmationTitle')"
              (close)="showDeleteModal = null"
              [minWidth]="250"
              [width]="450"
              >
              <kendo-window-titlebar>
                <h2>{{t('deleteConfirmationTitle')}}</h2>
                <button kendoWindowCloseAction></button>
              </kendo-window-titlebar>
              <p>{{t('deleteConfirmationMessage')}}</p>
              <button
                kendoButton
                class="mrm"
                (click)="showDeleteModal = null">
                {{t('cancelButton')}}
              </button>
              <button
                kendoButton
                class="error"
                (click)="onDelete(showDeleteModal)">
                {{t('deleteButton')}}
              </button>
            </kendo-window>
          }
        </section>
      </div>
    }
  </ng-container>
</ng-container>